module.exports = __webpack_public_path__ + "img/american_express.4dd61e56.jpg";